export default {
	mounted(el: any) {
		el.focus();
	}
}